import { Alert, AlertTitle } from '@material-ui/lab';
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import './Events.css';
import { useHistory, useParams } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { getAllFranchiseEventsDocument } from '../Backend/firebase/franchise-events';
import { getAllHealthCampsDocument } from '../Backend/firebase/health-camps';
import { getAllPharmaEventsDocument } from '../Backend/firebase/pharma-events';
import { getAllSportEventDocument } from '../Backend/firebase/sport-event';
import { getAllEmployerDocument, getAllEmployerDocumentWithCity } from '../Backend/firebase/user';
import { pushHealthCampsEventRecords, selectHealthCampsEventRecords, pushFranchiseEventRecords, selectFranchiseEventRecords, pushPharmaEventRecords, selectPharmaEventRecords, pushHealthySportsEventRecords, selectHealthySportsEventRecords } from '../DataStore/Slices/eventSlice';
import UpcomingFranchiseEvents from './UpcomingFranchiseEvents';
import { pushRetailerRecords, selectRetailerRecords } from '../DataStore/Slices/retailerSlice';
import TopRetailer from './TopRetailer';
import UpcomingHealthCamps from './UpcomingHealthCamps';
import UpcomingSportEvents from './UpcomingSportEvents';
import UpcomingPharmaEvents from './UpcomingPharmaEvents';

function AllRecords() {
    const history = useHistory();
    const dispatch = useDispatch();
    const retailerRecords = useSelector(selectRetailerRecords);
    const healthCampsEventRecords = useSelector(selectHealthCampsEventRecords);
    const pharmaEventRecords = useSelector(selectPharmaEventRecords);
    const healthySportsEventRecords = useSelector(selectHealthySportsEventRecords);
    const franchiseEventRecords = useSelector(selectFranchiseEventRecords);
    const { category } = useParams();


    const getAllRetailer = async () => {
        try {
            const getRetailer = await getAllEmployerDocument();
            dispatch(pushRetailerRecords({
                retailers: getRetailer
            }));
        } catch(error) {
            console.log("Home Screen Error Occur in Get All Retailer List ", error)
        }
    };

    useEffect(async () => {
        if (!retailerRecords) {
            await getAllRetailer();
        }
    }, [retailerRecords]);

    const getHealthCamps = async () => {
        try {
            let getAllHealthCamps = await getAllHealthCampsDocument();
            dispatch(pushHealthCampsEventRecords({
                events: getAllHealthCamps
            }));
        } catch(error) {
            console.log("Home Screen Error Occur in Get All Health Camps ", error)
        }
    };

    useEffect(async () => {
        if (!healthCampsEventRecords) {
            await getHealthCamps();
        }
    }, [healthCampsEventRecords]);

    const getFranchiseEvents = async () => {
        try {
            const getAllFranchiseEvents = await getAllFranchiseEventsDocument();;
            dispatch(pushFranchiseEventRecords({
                events: getAllFranchiseEvents
            }));
        } catch(error) {
            console.log("Home Screen Error Occur in Get All Franchise ", error)
        }
    };

    useEffect(async () => {
        if (!franchiseEventRecords) {
            await getFranchiseEvents();
        }
    }, [franchiseEventRecords]);

    const getPharmaEvents = async () => {
        try {
            let getAllPharmaEvents = await getAllPharmaEventsDocument();
            dispatch(pushPharmaEventRecords({
                events: getAllPharmaEvents
            }));
        } catch(error) {
            console.log("Home Screen Error Occur in Get All Health Camps ", error)
        }
    };

    useEffect(async () => {
        if (!pharmaEventRecords) {
            await getPharmaEvents();
        }
    }, [pharmaEventRecords]);

    const getSportsEvents = async () => {
        try {
            let getAllSportsEvents = await getAllSportEventDocument();
            dispatch(pushHealthySportsEventRecords({
                events: getAllSportsEvents
            }));
        } catch(error) {
            console.log("Home Screen Error Occur in Get All Sports Events ", error)
        }
    };

    useEffect(async () => {
        if (!healthySportsEventRecords) {
            await getSportsEvents();
        }
    }, [healthySportsEventRecords]);

    const routeOnPageByMedicalEvents = (uniqueId) => {
        history.push(`/medical-details/${uniqueId}`);
    }

    const routeOnPageBySportEvents = (uniqueId) => {
        history.push(`/sport-details/${uniqueId}`);
    }

    const routeOnPageByFranchiseEvents = (uniqueId) => {
        history.push(`/medical-details/${uniqueId}`);
    }

    const routeByRetailer = (uid) => {
        history.push(`/retailer-details/${uid}`);
    }

    return (
        <>
            <div className="container-fluid event-grid">
                <Helmet>
                    <meta name="description" content="Please contact us using this form if you face any problem. Our team will help you in any case..." />
                    <title>Events | Kaipsool Pharmatech</title>
                </Helmet>
                {category === "franchise-events" && <>
                    {(franchiseEventRecords && franchiseEventRecords.events.length > 0) ? <div className="row">
                        <div className="col-md-10 mx-auto about__us text-left">
                            <div className="col-md-12 text-left homeScreen__topSkillsHeading">
                                <span>Pharma Franchise Offerings</span>
                            </div>
                        </div>

                        <div className="col-md-10 md-offset-2 mx-auto about__us__row">
                            <div className="row mr-5">
                                {franchiseEventRecords.events.map(data => (
                                    <UpcomingFranchiseEvents
                                        key={data.uniqueId} 
                                        Id={data.uniqueId} 
                                        Image={data.eventImage}
                                        Title={data.eventName}
                                        Type={data.eventType}
                                        Location={data.location}
                                        City={data.city}
                                        Certification={data.certification}
                                        YearOfEstablishment={data.yearOfEstablishment}
                                        routeOnPage={() => routeOnPageByFranchiseEvents(data.uniqueId)} />
                                ))}
                            </div>
                        </div>
                    </div> : '' }
                </>}


                {category === "medical-store" && <>
                    {(retailerRecords && retailerRecords.retailers.length > 0) ? <div className="row">
                        <div className="col-md-10 mx-auto about__us text-left">
                            <div className="col-md-12 text-left homeScreen__topSkillsHeading">
                                <span>Top Medical Stores</span>
                            </div>
                        </div>

                        <div className="col-md-10 md-offset-2 mx-auto about__us__row">
                            <div className="row mr-5">
                                {retailerRecords.retailers.map(data => (
                                    <TopRetailer
                                        key={data.uid} 
                                        Id={data.uid} 
                                        Title={data.storeName}
                                        Address={data.storeAddress}
                                        Zipcode={data.zipcode}
                                        homeDelivery={data.homeDelivery}
                                        routeOnPage={() => routeByRetailer(data.uid)} />
                                ))}
                            </div>
                        </div>
                    </div> : '' }
                </>}

                {category === "health-camps" && <>
                    {(healthCampsEventRecords && healthCampsEventRecords.events.length > 0) ? <div className="row">
                        <div className="col-md-10 mx-auto about__us text-left">
                            <div className="col-md-12 text-left homeScreen__topSkillsHeading">
                                <span>Health Camps</span>
                            </div>
                        </div>

                        <div className="col-md-10 md-offset-2 mx-auto about__us__row">
                            <div className="row mr-5">
                                {healthCampsEventRecords.events.map(data => (
                                    <UpcomingHealthCamps
                                        key={data.uniqueId} 
                                        Id={data.uniqueId} 
                                        Image={data.eventImage}
                                        Title={data.eventName}
                                        Type={data.eventType}
                                        EventDate={data.eventDate}
                                        EventTime={data.eventTime}
                                        Location={data.location}
                                        Organizer={data.organizer}
                                        RegistrationClosingDate={data.registrationClosingDate}
                                        routeOnPage={() => routeOnPageByMedicalEvents(data.uniqueId)} />
                                ))}
                            </div>
                        </div>
                    </div> : '' }
                </>}
                
                {category === "healthy-sports" && <>
                    {(healthySportsEventRecords && healthySportsEventRecords.events.length > 0) ? <div className="row">
                        <div className="col-md-10 mx-auto text-left">
                            <div className="col-md-12 text-left homeScreen__topSkillsHeading">
                                <span>Healthy Sports Events</span>
                            </div>
                        </div>

                        <div className="col-md-10 md-offset-2 mx-auto about__us__row mt-3">
                            <div className="row mr-5">
                                {healthySportsEventRecords.events.map(data => (
                                    <UpcomingSportEvents 
                                        key={data.uniqueId} 
                                        Id={data.uniqueId} 
                                        Image={data.eventImage}
                                        Title={data.tournamentName}
                                        Type={data.eventCategory}
                                        StartDate={data.startDate}
                                        EndDate={data.endDate}
                                        Location={data.location}
                                        OrganizerName={data.organizerName}
                                        RegistrationClosingDate={data.registrationClosingDate}
                                        routeOnPage={() => routeOnPageBySportEvents(data.uniqueId)} />
                                ))}
                            </div>
                        </div>
                    </div> : ''}
                </>}
                
                {category === "pharma-events" &&<>
                    {(pharmaEventRecords && pharmaEventRecords.events.length > 0) ? <div className="row">
                        <div className="col-md-10 mx-auto text-left">
                            <div className="col-md-12 text-left homeScreen__topSkillsHeading">
                                <span>Pharma Events</span>
                            </div>
                        </div>

                        <div className="col-md-10 md-offset-2 mx-auto about__us__row mt-3">
                            <div className="row mr-5">
                                {pharmaEventRecords.events.map(data => (
                                    <UpcomingPharmaEvents 
                                        key={data.uniqueId} 
                                        Id={data.uniqueId} 
                                        Image={data.eventImage}
                                        Title={data.eventName}
                                        Type={data.eventType}
                                        EventDate={data.eventDate}
                                        EventTime={data.eventTime}
                                        Location={data.location}
                                        Organizer={data.organizer}
                                        RegistrationClosingDate={data.registrationClosingDate}
                                        routeOnPage={() => routeOnPageByMedicalEvents(data.uniqueId)}  />
                                ))}
                            </div>
                        </div>
                    </div> : ''}
                </>}
            </div>
        </>
    )
}

export default AllRecords
